import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MenuBar from "../../components/MenuBar";
import HeaderBar from "../../components/HeaderBar";
import { useAuth } from "../../context/AuthContext";
import CreditAddCreditContent from "./CreditAddCreditContent";
import { useCreditBranchFilter } from "./useCreditBranchFilter";
import CreditBranchSelector from "./CreditBranchSelector";

export default function CreditAddSalePage() {
  const navigate = useNavigate();
  const { user: storedUser } = useAuth();
  const { branch, setBranch, visibleBranches } = useCreditBranchFilter(storedUser);

  return (
    <div className="min-h-screen bg-slate-100/90">
      <Toaster position="top-right" />
      <MenuBar />
      <HeaderBar />
      <main className="mx-auto max-w-lg px-3 pb-24 pt-4 sm:px-4">
        <Link to="/credit-due" className="text-sm font-semibold text-indigo-600 hover:underline">
          ← Credit / Due
        </Link>
        <h1 className="mt-2 text-lg font-bold text-slate-900">Add manual credit (Udhar)</h1>
        <div className="mt-3 rounded-lg border border-slate-200 bg-white px-3 py-2">
          <CreditBranchSelector value={branch} onChange={setBranch} options={visibleBranches} />
        </div>
        <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <CreditAddCreditContent key={branch} branch={branch} onSuccess={() => navigate("/credit-due")} />
        </div>
      </main>
    </div>
  );
}
